(function() {
  'use strict';

  function updateLeadTimeProperty(form, variantId) {
    if (!form || !variantId) return;

    const propertyInput = form.querySelector('.js-lead-time-property');
    if (!propertyInput) return;

    const dataScript = form.querySelector('.js-lead-time-data');
    if (!dataScript) {
      // Single-variant product, value is already set server-side
      return;
    }

    try {
      const leadTimes = JSON.parse(dataScript.textContent);
      const value = leadTimes[variantId] || leadTimes[String(variantId)] || '';
      propertyInput.value = value;
    } catch (e) {
      console.warn('[lead-time-property] Failed to parse lead time data:', e);
    }
  }

  function getVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  // Listen for variant changes via Shopify's standard variant:change event
  document.addEventListener('variant:change', function(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('.js-product-form-main').forEach(function(form) {
      updateLeadTimeProperty(form, variant.id);
    });
  });

  // Fallback: watch the hidden id input for changes (covers themes that update it directly)
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-product-form-main').forEach(function(form) {
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      // Initial sync
      updateLeadTimeProperty(form, idInput.value);

      // Watch for programmatic changes to the id input
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'value') {
            updateLeadTimeProperty(form, idInput.value);
          }
        });
      });
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });

      // Also handle 'change' events on the input
      idInput.addEventListener('change', function() {
        updateLeadTimeProperty(form, idInput.value);
      });
    });
  });
})();